export const LOGIN_URL = "api/v1/pharmacy-user/login";
export const REGISTER_URL = "/auth/register";
export const GET_USER_URL = "/user";
export const GET_USERS_URL = "api/v1/user/search";
export const GET_PROFILE = "api/v1/pharmacy-user/profile";
export const UPDATE_PROFILE = "api/v1/pharmacy-user/profile";
export const UPDATE_PASSWORD = "api/v1/pharmacy-user/change-password";

export const GET_BOOKING_STATS_URL = "api/v1/lab-test-booking/stats/:pharmacyId";
export const GET_EMPLOYEE_DASHBOARD_DATA = "api/v1/lab-test-booking/employee-dashboard/:pharmacyId";
export const GET_PHARMACY_LEADERBOARD_URL = "api/v1/pharmacy/leaderboard/:pharmacyId";

export const GET_PHARMACY_TEST_LIST = "api/v1/pharmacy-test";
export const GET_BOOKING_LIST = "api/v1/lab-test-booking/:pharmacyId/all";
export const PHARMACY_SLOTS = "api/v1/pharmacy/:pharmacyId/slots";
export const PHARMACY_OPEN_DAYS = "api/v1/pharmacy/:pharmacyId/open-days";
export const CREATE_BOOKING = "api/v1/lab-test-booking/multiple";
export const CANCEL_BOOKING = "api/v1/lab-test-booking";
export const GET_BOOKING_DETAILS = "api/v1/lab-test-booking/details/:barcode";
export const SAVE_TEST_RESULTS = "api/v1/lab-test-booking/results";
export const PREVIEW_TEST_RESULTS = "api/v1/lab-test-booking/results/preview";
export const RESCHEDULE_BOOKING = "api/v1/lab-test-booking/reschedule";

export const GET_PHARMACY_TEAM_LIST = "api/v1/pharmacy-user";
export const MY_PHARMACY_LIST = "api/v1/pharmacy/my/list";

export const GET_PHARMACY_DETAILS = "api/v1/pharmacy/details";

export const UPDATE_PHARMACY_DETAILS = "api/v1/pharmacy";

export const ADD_LAB_TEST = "api/v1/pharmacy-test/:pharmacyId/link";
export const DELETE_LAB_TEST = "api/v1/pharmacy-test";

export const GET_LAB_TEST_LIST = "api/v1/labtest";

export const CREATE_PHARMACY_USER = "api/v1/pharmacy-user/register";

export const DELETE_PHARMACY_USER = "api/v1/pharmacy-user";
export const ADD_PHARMACIES_TO_USER = "api/v1/pharmacy-user";

export const SEND_LAB_TEST_EMAIL = "api/v1/lab-test-booking/send-email";
export const UPDATE_BOOKING_DETAILS = "api/v1/lab-test-booking/update-details";

export const GET_TUTORIALS = "api/v1/tutorials";
export const CREATE_TUTORIAL = "api/v1/tutorials";

// Pharmacy Appointments API endpoints
export const PHARMACY_APPOINTMENTS_BASE = "api/v1/pharmacy-appointments";
export const CREATE_PHARMACY_APPOINTMENT = "api/v1/pharmacy-appointments/:pharmacyId";
export const UPDATE_PHARMACY_APPOINTMENT = "api/v1/pharmacy-appointments";
export const DELETE_PHARMACY_APPOINTMENT = "api/v1/pharmacy-appointments";
export const GET_MY_PHARMACY_APPOINTMENTS = "api/v1/pharmacy-appointments/pharmacy/:pharmacyId/appointments";
export const GET_MY_PHARMACY_BOOKINGS = "api/v1/pharmacy-appointments/pharmacy/:pharmacyId/bookings";
export const UPDATE_BOOKING_STATUS = "api/v1/pharmacy-appointments/booking";
export const CANCEL_PHARMACY_BOOKING = "api/v1/pharmacy-appointments/booking";
export const BOOK_APPOINTMENT_FOR_USER = "api/v1/pharmacy-appointments/pharmacy/:pharmacyId/book-for-user";
export const GET_APPOINTMENT_TIME_SLOTS = "api/v1/pharmacy-appointments/time-slots";
export const GET_APPOINTMENT_OPEN_DAYS = "api/v1/pharmacy-appointments/open-days/:pharmacyId";